import axios from 'axios';

const setGoogleData = {

    methods: {
        /**
         * Updates the googleData col in the database.
         * @param {data} str The json, stringified if not partial
         * @param {partial} str Optional the .metric that's specifically being set
         * @param {clientSlug} str Optional, normally uses the getClientSlug function
         */
        setGoogleData(data, partial = false, clientSlug = '') {
            const params = new URLSearchParams();
            if (clientSlug) {
                params.append('clientSlug', clientSlug);
            } else {
                params.append('clientSlug', this.getClientSlug);
            }
            if (partial) {
                // If only 1 metric is being updated use the setClientGoogleMetric function
                let theValue = { 'metricname': partial, 'data': data }
				this.$store.commit("client/setClientGoogleMetric", theValue)
            } else {
                // The whole google is updating so do the whole axois bit.
                params.append('data', data);
                // console.log(params);
                axios.post('/api/clients/googleData/updateGoogleData', params, {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(async () => {
                    console.log('Google Data set');
                })
                .catch((err) => console.error(err.response));
            }
        },
    },
};

export default setGoogleData;
